// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

/**
 * 已报废, after a serial on the record (§8.7): the part was recorded as scrapped when an
 * archive was scrapped — this one, or one it was taken from and entered here anyway.
 */

import { useTranslation } from "react-i18next";
import type { ArchiveItem } from "@/api/types";

export function ScrappedTag({ item }: { item: Pick<ArchiveItem, "scrapped"> }) {
  const { t } = useTranslation();
  if (!item.scrapped) return null;
  return (
    <span className="badge badge-scrapped serial-tag" title={t("archive.partScrappedHint")}>
      {t("archive.partScrapped")}
    </span>
  );
}
